import { useContext, useState } from "react";
import { Avatar, Badge, Button, Flex, Layout, Menu, Popover } from "antd";
import "./style.css";
import MenuSide from "../menu";
import { UserOutlined } from "@ant-design/icons";
// import ProfileCard from "../../../auth/profile-card";
import { FiBell } from "react-icons/fi";
import AppContext from "../../../../contexts/app/context";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../../contexts/auth/context";
import { ArrowRightOutlined } from "@ant-design/icons";

const SideBar = () => {
  const navigate = useNavigate();
  const { screenSize } = useContext(AppContext);

  const [collapsed, setCollapsed] = useState(false);

  // User Popover
  const [userPopoverVisible, setUserPopoverVisible] = useState(false);

  // Auth context
  const { authUser: user } = useContext(AuthContext);

  return (
    <Layout.Sider
      className="sidebar"
      width={"17.5rem"}
      theme="light"
      collapsed={screenSize === "mobileOrTablet" || collapsed}
      collapsible={screenSize !== "mobileOrTablet"}
      onCollapse={setCollapsed}
      trigger={null}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Flex
            style={{ padding: "10px" }}
            justify="space-between"
            align="center"
          >
            <h1 style={{ marginInlineStart: "20px" }}>Logo</h1>
            <Button
              shape="circle"
              color=""
              icon={<ArrowRightOutlined />}
            ></Button>
          </Flex>
          <MenuSide />
        </div>
        {/* Footer */}
        <div style={{ color: "white", textAlign: "center" }}>
          <h5
            style={{
              opacity: "0.8",
            }}
          >
            Tajir
          </h5>
          <h5 style={{ opacity: "0.7" }}>الحقوق محفوظة © 2024</h5>
        </div>
      </div>
    </Layout.Sider>
  );
};
export default SideBar;
